import script from "./NoteAttachmentElement.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteAttachmentElement.vue?vue&type=script&setup=true&lang=js"

import "./NoteAttachmentElement.vue?vue&type=style&index=0&id=74716d6e&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74716d6e"]])

export default __exports__